import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  namedAttributes: {
    id: Number,
    code: String,
    description: String,
    statusValue: String,
  },

  defaults: {
    id: null,
    code: null,
    description: null,
    statusValue: null,
  },

  isRejected() {
    return "REJECTED" === this.get("statusValue");
  },

  isAccepted() {
    return "ACCEPTED" === this.get("statusValue");
  },
});

export { Model as default };
